import { notifyParentThemeChanged } from '../util/parentShell';
import { isSingleThemeMode, SINGLE_THEME_ID } from './singleTheme';

const VALID_THEME_IDS = new Set([
  100, 101, 111, 121, 131, 141, 151, 161, 171, 181,
]);

/** Neutral dashboard / bootstrap default — never push this up to the shell. */
const SHELL_DEFAULT_THEME_ID = 101;

export function applyTheme(themeId: number): void {
  // Single-theme mode overrides every product/category colour, so callers that
  // resolved a category theme (useProductCategoryTheme, shell THEME_CHANGED)
  // need no gate of their own.
  const resolved = isSingleThemeMode() ? SINGLE_THEME_ID : themeId;

  if (!VALID_THEME_IDS.has(resolved)) {
    return;
  }

  // Bail on a no-op re-apply: it would bounce THEME_CHANGED back to the shell,
  // which re-posts it here, and so on.
  if (document.documentElement.dataset.theme === String(resolved)) {
    return;
  }

  document.documentElement.dataset.theme = String(resolved);

  // Only product themes update shell chrome. Posting 101 on iframe mount was
  // wiping the header theme the parent already applied from the selected product;
  // 100 is shell-driven, so echoing it back would fight the shell the same way.
  if (resolved !== SHELL_DEFAULT_THEME_ID && resolved !== SINGLE_THEME_ID) {
    notifyParentThemeChanged(resolved);
  }
}
